export const PREVIEW_CROSSFADE_DURATION_MS = 500;

export const PREVIEW_CROSSFADE_CLASS_NAME =
  'motion-safe:transition-opacity motion-safe:duration-[500ms] motion-safe:ease-[cubic-bezier(0.5,0,0,0.75)]';
